import { useMigrateTranscriptDefaultTabToNote } from '@/app-shell/app-root/migrations/hooks/useMigrateTranscriptDefaultTabToNote';

export function Migrations() {
  useMigrateTranscriptDefaultTabToNote();
  return null;
}
